jQuery(document).ready(function () {
  'use strict';

  // jQuery('.menu > ul > li:has( > ul)').addClass('menu-dropdown-icon');
  //Checks if li has sub (ul) and adds class for toggle icon - just an UI

  jQuery('.new-design-header .menu > ul > li > ul:not(:has(ul))').addClass('normal-sub');
  //Checks if drodown menu's li elements have anothere level (ul), if not the dropdown is shown as regular dropdown, not a mega menu (thanks Luka Kladaric)

  //Adds menu-mobile class (for mobile toggle menu) before the normal menu
  //Mobile menu is hidden if width is more then 959px, but normal menu is displayed
  //Normal menu is hidden if width is below 959px, and jquery adds mobile menu
  //Done this way so it can be used with wordpress without any trouble
  var hoverTimeout;
  var activeItem = null;

  function closeAllSubmenus() {
    jQuery('.menu > ul > li').removeClass('hover');
    jQuery('.menu > ul > li > ul').stop(true, true).fadeOut(150);
  }

  jQuery('.menu > ul > li').hover(
    function (e) {
      if (jQuery(window).width() > 943) {
        clearTimeout(hoverTimeout);
        closeAllSubmenus();
        activeItem = jQuery(this);
        jQuery(this).addClass('hover');
        jQuery(this).children('ul').stop(true, true).fadeIn(150);
        jQuery(this).children('ul').css('display', 'grid');
        if (
          !jQuery(this).children('ul').hasClass('normal-sub') &&
          jQuery(this).children('ul').children('li').length >= 4
        ) {
          var ul = jQuery(this).children('ul');
          var li = ul.children('li');
          var liCount = li.length;
          ul.css('grid-template-columns', '1fr 1fr 1fr');
          ul.css('grid-template-areas', '"item1 item2 item4" "item1 item3 item4"');
          if (ul.hasClass('has-callout')) {
            ul.css('grid-template-areas', '"item1 item2 item4" "item1 item3 item5"');
            ul.find('.callout').css('grid-area', 'item5');
          }
          ul.css('grid-template-rows', 'auto');
          li.eq(0).css('grid-area', 'item1');
          li.eq(1).css('grid-area', 'item2');
          li.eq(2).css('grid-area', 'item3');
          li.eq(3).css('grid-area', 'item4');
        }
        // if the ul has the class normal sub and also the class has-callout, then do a grid-template columns with 2 columns
        if (jQuery(this).children('ul').hasClass('normal-sub') && jQuery(this).children('ul').hasClass('has-callout')) {
          jQuery(this).children('ul').css('width', '40vw');
          jQuery(this).children('ul').css('max-width', '550px');
          jQuery(this).children('ul').css('padding', '26px 20px');
          var $ul = jQuery(this).children('ul');
          if (
            $ul.data('title') &&
            $ul.data('link') &&
            $ul.data('title').trim() !== '' &&
            $ul.data('link').trim() !== ''
          ) {
            if (!$ul.find('.grid-container').length) {
              $ul.children('li').wrapAll("<div class='grid-container'></div>");
              $ul
                .find('.grid-container')
                .prepend(
                  '<span class="grid-title"><a href="' + $ul.data('link') + '">' + $ul.data('title') + '</a></span>'
                );
            }
          } else {
            if (!$ul.find('.grid-container').length) {
              $ul.children('li').wrapAll("<div class='grid-container'></div>");
            }
          }
          jQuery(this).children('ul').css('grid-template-columns', '1fr 1fr');
          // assign to the li, grid-column: 1
          jQuery(this).children('ul').children('li').css('grid-column', '1');

          jQuery(this).children('ul').find('.callout').css('grid-column', '2');
          // jQuery(this).children("ul").find('.callout').css('grid-row', '1 / -1');
          jQuery(this).children('ul').find('.callout').css('align-self', 'start');
        }
        e.preventDefault();
      }
    },
    function () {
      if (jQuery(window).width() > 943) {
        hoverTimeout = setTimeout(function () {
          if (activeItem === null || !activeItem.is(':hover')) {
            closeAllSubmenus();
            activeItem = null;
          }
        }, 100);
      }
    }
  );

  jQuery('.menu > ul > li > ul').hover(
    function () {
      if (jQuery(window).width() > 943) {
        clearTimeout(hoverTimeout);
      }
    },
    function () {
      if (jQuery(window).width() > 943) {
        hoverTimeout = setTimeout(function () {
          if (activeItem === null || !activeItem.is(':hover')) {
            closeAllSubmenus();
            activeItem = null;
          }
        }, 100);
      }
    }
  );

  //If width is more than 943px dropdowns are displayed on hover
  jQuery('.new-design-header .menu > ul > li.main-menu-link').click(function (e) {
    // Only run click logic for mobile widths
    if (jQuery(window).width() < 943) {
      e.stopImmediatePropagation(); // Prevent event bubbling
      var $this = jQuery(this);
      var thisMenu = $this.children('ul.parent-menu-wrapper'); // Target the direct child ul

      // Check if the clicked menu is already visible
      if (thisMenu.is(':visible')) {
        // If visible, hide it
        thisMenu.fadeOut(150);
        $this.removeClass('mobile-active'); // Optional: remove active class
      } else {
        // If not visible, hide all sibling submenus first
        $this.siblings().children('ul.parent-menu-wrapper').fadeOut(150);
        $this.siblings().removeClass('mobile-active'); // Optional: remove active class from siblings

        // Show the clicked submenu
        thisMenu.fadeIn(150);
        $this.addClass('mobile-active'); // Optional: add active class

        // --- Add grid-title logic specifically for mobile ---
        var $ul = thisMenu; // Use the reference to the submenu UL
        if (
          $ul.length && // Make sure the submenu ul exists
          $ul.data('title') &&
          $ul.data('link') &&
          $ul.data('title').trim() !== '' &&
          $ul.data('link').trim() !== ''
          // Add any other conditions if the title should only appear for specific mobile menu types
          // For example: && $ul.hasClass('some-mobile-specific-class')
        ) {
          // Check if the title span doesn't already exist inside this specific ul
          if (!$ul.children('span.grid-title').length) {
            // Prepend the title *directly* to the mobile submenu ul
            $ul.prepend(
              // Added a 'mobile-grid-title' class for potential specific styling
              '<span class="grid-title mobile-grid-title"><a href="' +
                $ul.data('link') +
                '">' +
                $ul.data('title') +
                '</a></span>'
            );
          }
        }
        // --- End mobile grid-title logic ---
      }
    }
    // If width is >= 943, let the hover logic handle it (or default link behavior if no submenu)
  });

  // Keep the stopPropagation for links inside the mobile menu
  jQuery('.new-design-header > .mobile-menu > .menu > ul > li.main-menu-link ul a').click(function (e) {
    e.stopPropagation();
  });

  // Keep the mobile menu toggle logic
  jQuery('.new-design-header .menu-mobile').click(function (e) {
    jQuery('.menu > ul').toggleClass('show-on-mobile');
    e.preventDefault();
  });

  // Tab menu functionality for by_column_two layout
  jQuery('.tab-menu-container .tab-button').click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    var tabId = jQuery(this).data('tab');
    var tabContainer = jQuery(this).closest('.tab-menu-container');

    tabContainer.find('.tab-button').removeClass('active');
    jQuery(this).addClass('active');

    tabContainer.find('.tab-pane').removeClass('active');
    tabContainer.find('#' + tabId).addClass('active');

    var parentMenu = jQuery(this).closest('.parent-menu-wrapper');
    parentMenu.stop(true, true).show();
    parentMenu.css('opacity', '1');
    parentMenu.css('display', 'grid');
  });

  // Main function to initialize the header
  function initializeHeader() {
    const scrollLock = makeScrollLock();
    makeCalcAppHeight();

    const headerContainer = document.querySelector('header.new-design-header');
    // Corrected selector for mobileMenuToggler
    const mobileMenuToggler = headerContainer.querySelector('.mobile-menu-toggler');

    // Ensure mobileMenuToggler exists before adding listener
    if (mobileMenuToggler) {
      mobileMenuToggler.addEventListener('click', () => {
        headerContainer.classList.toggle('mobile-menu-active');
        mobileMenuToggler.classList.toggle('active');
        // Corrected selector for the mobile menu container itself
        const mobileMenuElement = headerContainer.querySelector('.js-mobile-menu');
        if (mobileMenuElement) {
          mobileMenuElement.classList.toggle('active');
        }
        // Use classList.contains on the toggler itself
        scrollLock[mobileMenuToggler.classList.contains('active') ? 'lock' : 'unlock']();
      });
    }

    const desktopMediaQuery = window.matchMedia('(min-width: 1024px)');

    // Initial check for desktopMediaQuery
    if (desktopMediaQuery.matches) {
      // Add background only if NOT transparent initially
      if (!headerContainer.classList.contains('transparent-header')) {
        headerContainer.classList.add('!bg-black/20'); // Or your desired desktop background class
      }
    }

    desktopMediaQuery.addEventListener('change', (event) => {
      // Add background only if NOT transparent initially and on desktop
      if (event.matches && !headerContainer.classList.contains('transparent-header')) {
        headerContainer.classList.add('!bg-black/20');
      } else {
        headerContainer.classList.remove('!bg-black/20');
      }
    });

    const toggleSticky = () => {
      const isSticky = window.scrollY > 5;
      headerContainer.classList.toggle('sticky', isSticky);
      // Also handle background change on scroll if needed, considering transparency
      if (!headerContainer.classList.contains('transparent-header')) {
        headerContainer.classList.toggle('!bg-black/20', isSticky || desktopMediaQuery.matches);
      } else {
        // If transparent, only add bg when sticky, regardless of desktop view
        headerContainer.classList.toggle('!bg-black/20', isSticky); // Or your sticky background class
      }
    };

    window.addEventListener('scroll', toggleSticky);
    // Initial call to set sticky state
    toggleSticky();
  }

  // Function to create scroll lock functionality
  function makeScrollLock({ isLocked = false } = {}) {
    let lastScrollPosition = -1;

    if (isLocked) lock();

    return Object.freeze({
      isLocked: () => isLocked,
      getLastScrollPosition: () => lastScrollPosition,
      lock,
      unlock,
    });

    function lock() {
      lastScrollPosition = window.scrollY;
      document.body.style.top = `-${lastScrollPosition}px`;
      document.body.classList.add('scroll-lock');
      isLocked = true;
    }

    function unlock() {
      document.body.classList.remove('scroll-lock');
      document.body.style.removeProperty('top');
      window.scrollTo(0, lastScrollPosition);
      isLocked = false;
    }
  }

  // Function to calculate app height
  function makeCalcAppHeight() {
    const _isIOSDevice = !!navigator.platform.match(/iPhone|iPod|iPad/);

    if (_isIOSDevice) {
      const calcAppHeight = () => {
        const doc = document.documentElement;
        doc.style.setProperty('--app-height', `${window.innerHeight}px`);
      };
      calcAppHeight();

      window.addEventListener('resize', () => {
        setTimeout(calcAppHeight, 100);
      });
    }
  }

  initializeHeader();
});
